import {
    Badge,
    Button,
    Icon,
    Link,
    TextField,
    Tooltip,
    Modal,
    Thumbnail,
    Popover,
    ActionList,
    Pagination,
    Text,
    BlockStack,
    InlineStack,
    Card,
    Box,
    Divider,
    InlineGrid,
    Bleed
} from '@shopify/polaris';
import {
    SearchMinor, ExternalMinor
} from "@shopify/polaris-icons";
import { Table, Pagination as AntdPagination } from 'antd';
import React, { useCallback, useState, useEffect, ReactElement, useContext } from 'react';
import { DI, DIProps } from '../../../../Core';
import debounce from 'lodash/debounce';
import Noimage from "../../../../../public/files/noImage.png";
import AmazonBtnIcon from "../../../../Asests/Images/amazon_icon.png";
import { UnlinkingSkeleton } from '../skeleton/LinkingSkeleton';
import ProductWiseAction from './ProductWiseAction';
import SyncModal from './SyncModal';
import { ProductLinkingContext } from './utils/context/context'
import { useTranslation } from "react-i18next";
import { globalState } from 'src/Services';
import { amazon_regions } from '../../Onboarding/components/onboardinghelper';
import { isAdminLoggedIn } from '../../Panel/index';
import { ViewMoreInfo } from './utils/utils';
import { LazyThumbnail } from '../../Editproduct/components/Image/Image';
import { modifyImageUrl } from '../../Listing Grid/Utilities/Helper';


interface Props extends DIProps {
    viewSku?: string;
}
/**
 * This component is responsible for the dashboard structure
 * @param props
 * @returns
 */

var timer: ReturnType<typeof setTimeout>;

function Unlinked(props: Props): ReactElement {
    const { t } = useTranslation();
    const myContext: any = useContext(ProductLinkingContext);

    const necessaryDetails = { ...myContext.necessaryDetails };
    // const [start, setStart] = useState<boolean>(false)
    const [inputValue, setInputValue] = useState(props.viewSku ?? "");
    const [tableLoading, setTableLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [data, setData] = useState([]);
    const [shopifyProducts, setShopifyProducts] = useState<any>([]);
    const [modalData1, setModalData1] = useState<JSX.Element>(<></>);
    const [linkModal1, setLinkModal1] = useState(false);
    const [deleteModal, setdeleteModal] = useState(false);
    const [linkModal2, setLinkModal2] = useState(false);
    const [shopifytableLoading, setshopifyTableLoading] = useState(false);
    const [isVariant, setisVariant] = useState(false);
    const [variation, setvariation] = useState<boolean>(false)
    const [shopifyData, setShopifyData] = useState([]);
    const [shopifySearch, setShopifySearch] = useState("");
    const [shopifyDataToLink, setShopifyDataToLink] = useState([]);
    const [modalLinkButton, setModalLinkButton] = useState(false);
    const [modalLoader, setmodalLoader] = useState(true);
    const [finalData, setFinalData] = useState({
        "_id": "",
        "source_product_id": "",
        "image-url": "",
        "seller-sku": "seller-sku"
    });
    const [summaryOfTable, setSummaryOfTable] = useState<JSX.Element>(<></>);
    const [hasApproved, setHasApproved] = useState(false);
    const [undoApproveLoading, setUndoApproveLoading] = useState(false);
    const [popup, setpopup] = useState(false);
    const [sortLabel, setSortLabel] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [count, setCount] = useState(10);
    const [hasPageChanged, setHasPageChanged] = useState(false);
    const [statusOption, setStatusOption] = useState([]);
    const [firstRender, setfirstRender] = useState(true);
    const [dataFoundOnAmazon, setDataFoundOnAmazon] = useState<boolean>(false);
    const [syncModal, setsyncModal] = useState(false);
    const [actiontype, setactiontype] = useState({});
    const [syncmodalLoading, setsyncmodalLoading] = useState(false);

    const unlinkedColumns: any = [
        {
            title: "",
            dataIndex: "image",
            key: "image",
            width: 70,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">
                {t("Product")}
            </Text>,
            dataIndex: "product",
            key: "product",
            width: 400,
        },
        {
            title: "",
            dataIndex: "status",
            key: "status",
            width: 100,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">
                {t("Amazon SKU and Barcode")}
            </Text>,
            dataIndex: "sku",
            key: "sku",
            width: 250,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">
                {t("Action")}
            </Text>,
            dataIndex: "action",
            key: "action",
            width: 150,
            align: 'center',
        },
    ];
    const [deleteData, setdeleAction] = useState<any>({})

    const headings: any = [
        { title: <Text variant="headingSm" as="h6">{t("Image")}</Text>, dataIndex: "image", width: 100 },
        { title: <Text variant="headingSm" as="h6">{t("Product Title")}</Text>, dataIndex: "title", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Shopify SKU")}</Text>, dataIndex: "sku", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Barcode")}</Text>, dataIndex: "barcode", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Action")}</Text>, dataIndex: "action", width: 100, align: "center", },
    ];

    const headings2: any = [
        { title: <Text variant="headingSm" as="h6">{t("Image")}</Text>, dataIndex: "image", width: 100 },
        { title: <Text variant="headingSm" as="h6">{t("Product Title")}</Text>, dataIndex: "title", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Shopify SKU")}</Text>, dataIndex: "sku", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Barcode")}</Text>, dataIndex: "barcode", width: 200 },
    ];

    const handleTotalpage = (totalProducts: number) => {
        let pages = 0;
        if (totalProducts % count === 0) {
            pages = totalProducts / count;
        } else {
            pages = Math.trunc(totalProducts / count) + 1;
        }
        setTotalPage(pages);
    };

    const getUnlinkedListing = () => {
        let data: any = {};
        let filters: any = {};
        data = {
            ...necessaryDetails,
            'data': {
                'matched': "false",
                'activePage': currentPage,
                'count': count,
            },
            'fulfillment-channel': myContext.fulfillmentType == 'FBM' ? 'DEFAULT' : 'FBA',
        }
        if (firstRender && props.location.state?.sku) {
            data = { ...data, filter: { 'seller-sku': { '1': props.location.state.sku } } }
        }
        else if (inputValue != "") {
            filters = {
                'or_filter': { 'item-name': { "3": inputValue }, 'seller-sku': { "3": inputValue }, 'product-id': { "3": inputValue } }
            }
            data = Object.assign({ ...data }, filters);
        }
        firstRender && setfirstRender(false)

        if (sortLabel !== "") {
            data = Object.assign({ ...data }, { "sortBy": sortLabel });
        }

        if (!tableLoading) setTableLoading(true);
        props.di.POST(`amazon/product/getAmazonListing`, data).then(val => {
            if (val.success) {
                myContext.getListingCount('not_linked');
                myContext.renderListingCount({ 'not_linked': val?.total_products });
                handleTotalpage(val?.total_products);
                setProducts(val.response);
                setTableLoading(false);
            } else {
                setTableLoading(false);
                props.error(t(val.error) ?? t("Request unsuccessful"));
            }
        })
    };



    const getAmazonStatus = () => {
        let data: any = {};
        data = {
            ...necessaryDetails,
        };
        props.di.POST(`amazon/product/getAmazonStatus`, data).then(val => {
            if (val.success) {
                let status: any = [];
                if (val?.data) {
                    val.data.forEach((e: any) => {
                        if (e !== 'Deleted') {
                            status.push({
                                'content': t(e),
                                'onAction': () => handleActionList(e)
                            })
                        }
                    })
                }
                setStatusOption(status);
            } else {
                props.error(t(val.message) ?? t("Request unsuccessful"));
            }
        });
    };

    useEffect(() => {
        // setIsOpen(false)
        getAmazonStatus();
        if (props?.location?.state?.from == "transferOrder") {
            setInputValue(props?.location?.state?.sku)
        }
    }, [])

    const handleManualMap = () => {
        if (finalData._id !== "" && finalData?.["source_product_id"] !== "") {
            let data: any = {};
            data = {
                ...necessaryDetails,
                'data': {
                    _id: finalData._id,
                    source_product_id: finalData?.["source_product_id"],
                }
            };
            setModalLinkButton(true);
            props.di.POST(`amazon/product/manualMap`, data).then(val => {
                if (val.success) {
                    if (props?.location?.state?.from == 'transferOrder') {
                        props.history('../transfer-order', { state: props?.location?.state });
                    }
                    props.success(t(val.message));
                    setLinkModal1(false);
                    setLinkModal2(false);
                    setHasApproved(true);
                    getUnlinkedListing();
                    clearTimeout(timer);
                    renderSummaryOfTable('approve', finalData);
                    getUnmatchedShopifyProducts();
                } else {
                    props.error(t(val.message) ?? t("Request unsuccessful"));
                }
                setModalLinkButton(false);
            });
        } else {
            props.error(t("Kindly select valid product data"));
        }
    }

    var debounceListing = debounce(() => getUnlinkedListing(), 1000);

    useEffect(() => {
        getUnlinkedListing();
        // }, [hasPageChanged, sortLabel, props.fulfillmentType]);
    }, [hasPageChanged, sortLabel, myContext.fulfillmentType]);

    useEffect(() => {
        debounceListing();
    }, [inputValue]);

    useEffect(() => {
        return () => {
            debounceListing.cancel();
        };
    }, [debounceListing]);

    useEffect(() => {
        renderUnlinkedListing();
    }, [products]);

    const syncAction = (product_ids?: any, operation?: boolean) => {
        setsyncmodalLoading(true);
        let url: string = 'amazon/product/automateSync';
        let DataToSend = {
            ...necessaryDetails,
            data: {
                product_ids: [product_ids],
                operation,
            },
        };
        props.di.POST(url, DataToSend).then((response) => {
            if (response.success) {
                setsyncModal(false);
                setsyncmodalLoading(false);
                props.success(t(response.message));
            } else {
                setsyncModal(false);
                setsyncmodalLoading(false);
                props.error(t(response.message));
            }
            getUnlinkedListing();
        });
    };

    const button: any = <InlineStack gap="100" blockAlign='center'>
        <img src={AmazonBtnIcon} height="14px" width="14px" />
        <Icon
            source={ExternalMinor}
            tone="info"
        />
    </InlineStack>;

    const renderUnlinkedListing = () => {
        let unlinkedData: any = [];
        if (products?.length > 0) {
            products?.forEach((val: any, i) => {
                let current_shop_currency: any = amazon_regions.filter((value: any) => value?.currency == props?.redux?.current?.source?.currency)?.[0];
                unlinkedData.push(
                    {
                        key: i,
                        // image: <img height={"60px"} width={"60px"} src={val?.['image-url'] && val?.['image-url'] != "" ? val?.['image-url'] : Noimage} />,
                        image: <LazyThumbnail
                            src={val?.['image-url'] && val?.['image-url'] != "" ? modifyImageUrl(val?.['image-url']) : Noimage}
                            alt='productImages'
                            key={val?.['image-url'] && val?.['image-url'] != "" ? modifyImageUrl(val?.['image-url']) : Noimage + 'Thumbnail' + Math.random()}
                            size='medium'
                            className='custom-linking-lazy__thumbnail'
                        />,
                        product:
                            <BlockStack gap='100'>
                                {val?.['item-name']?.length > 100 ?
                                    <Tooltip content={val['item-name']}>
                                        <Text as='h3' variant='headingSm'>{val['item-name'].substring(0, 100)}...</Text>
                                    </Tooltip>
                                    :
                                    <Text as='h3' variant='headingSm'>{val['item-name']}</Text>
                                }
                                {/* <Link url={myContext.viewOnAmazon(val?.['asin1'])} target='_blank' removeUnderline>
                                    View on Amazon
                                </Link> */}
                                <InlineStack gap='300' wrap={false} blockAlign='center'>
                                    <div>
                                        <Button url={myContext.viewOnAmazon(val?.['asin1'])} target='_blank'>{button}</Button>
                                    </div>
                                    <ViewMoreInfo val={val} renderStatusOfProduct={renderStatusOfProduct} current_shop_currency={current_shop_currency} />
                                </InlineStack>
                                <div>
                                    {val?.['type'] === "variation" ? <Badge tone="info">{t("Parent")}</Badge> : null}
                                </div>
                            </BlockStack>,
                        status: renderStatusOfProduct(val?.['status']),
                        sku: <BlockStack gap="100">
                            <InlineStack gap="100">
                                <Text as="p" fontWeight="medium">
                                    {t("SKU:")}
                                </Text>
                                <Text as='p' tone="subdued">{val?.['seller-sku']}</Text>
                            </InlineStack>
                            <InlineStack gap="100">
                                <Text as="p" fontWeight="medium">
                                    {t("Barcode:")}
                                </Text>
                                <Text as='p' tone="subdued">{val?.['product-id']}</Text>
                            </InlineStack>
                        </BlockStack>,
                        action: <InlineStack gap="200" align='center'>
                            <Button id='failedOrder_tour_7' size='slim' variant='primary' onClick={() => {
                                if (val?.type == 'variation') { setisVariant(true) }
                                else (setisVariant(false))
                                setvariation(val?.['type'] === "variation")
                                handleLink1Modal();
                                getUnmatchedShopifyProducts(val?.['type'] === "variation" ? "variation" : "simple")
                                renderModal1Data(val);
                            }}>{t("Link")}</Button>
                            <ProductWiseAction
                                syncModal={syncModal}
                                setactiontype={setactiontype}
                                setsyncModal={setsyncModal}
                                row={val}
                                deleteModel={{
                                    modalLoader,
                                    setmodalLoader,
                                    handledeleteproductApi,
                                    modalData1,
                                    dataFoundOnAmazon,
                                    handledeleteproduct,
                                    val,
                                }}
                                {...props}
                            />
                        </InlineStack>
                    },
                )
            })
        }
        setData(unlinkedData);
    }

    // useEffect(() => {
    //     getUnmatchedShopifyProducts();
    // }, [])

    const handleShopifySearch = useCallback((value: any) => { setpage(1); setShopifySearch(value) }, []);
    const updateText = useCallback((value: any) => { setCurrentPage(1); setInputValue(value) }, []);
    const handleClearButtonClick = useCallback(() => updateText(''), []);

    const handleLink1Modal = () => {
        setShopifySearch("");
        setLinkModal1(!linkModal1);
        // setvariation(false)
    }

    const handledeleteproduct = (val: any) => {
        renderModal1Data(val);
        setdeleteModal(!deleteModal);
        let obj: any = {
            user_id: val?.user_id,
            sku: val?.["seller-sku"]
        }
        setdeleAction({ ...obj })
        getSingleProductFromAmazon(obj);
    }

    const handledeleteproductApi = () => {
        setdeleteModal(!deleteModal);
        let data: any = {};
        data = {
            ...necessaryDetails,
            deleteData,
            dataFoundOnAmazon
        };
        props.di.POST(`amazon/request/DeleteProductFromAmazon`, data).then(val => {
            if (val.success) {
                props.success(t(val.message));
                getUnlinkedListing();
                getAmazonStatus();

            } else {
                props.error(t(val.message) ?? t("Request unsuccessful"));
            }
        });

    }

    const getSingleProductFromAmazon = (obj: any) => {
        setdeleteModal(true);
        // props.di.POST("",{})
        let data: any = {};
        data = {
            ...necessaryDetails,
            "CheckData": { ...obj }
        };
        props.di.POST(`amazon/request/CheckDataOnAmazon`, data).then(val => {
            if (val.success) {
                let status: any = [];
                if (val?.data) {
                    val.data.forEach((e: any) => {
                        status.push({
                            'content': e,
                            'onAction': () => handleActionList(e)
                        })
                    })
                }

                setStatusOption(status);
                props.success(t(val.message));
                getUnlinkedListing();
                getAmazonStatus();
                setDataFoundOnAmazon(true);

            } else {
                props.error(t(val.message) ?? t("Request unsuccessful"));
                setDataFoundOnAmazon(false);
            }
            setmodalLoader(false);
        });
    }

    const handleLink2Modal = () => {
        setLinkModal2(!linkModal2);
    }

    const handleBackOfLink2Modal = () => {
        setModalLinkButton(false)
        setLinkModal2(false);
        setLinkModal1(true);
    }

    const renderStatusOfProduct = (status: string) => {
        if (status === "Active") {
            return (<Badge tone="success">{t(status)}</Badge>);
        }
        else if (status === "Incomplete") {
            return (<Badge tone="warning">{t(status)}</Badge>)
        }
        return (<Badge tone="critical">{t(status)}</Badge>);
    }

    const renderModal1Data = (val: any) => {

        let modaldata: JSX.Element = <></>;
        modaldata = <div className="custom-productlinking">
            <BlockStack gap="800">
                <Text as='h3' variant='headingSm'>{t("AMAZON PRODUCT")}</Text>
                <InlineStack gap='400'>
                    <InlineStack wrap={false} gap='400'>
                        <LazyThumbnail
                            src={val?.['image-url'] && val?.['image-url'] != "" ? modifyImageUrl(val?.['image-url']) : Noimage}
                            alt='productImages'
                            key={val?.['image-url'] && val?.['image-url'] != "" ? modifyImageUrl(val?.['image-url']) : Noimage + 'Thumbnail' + Math.random()}
                            size='medium'
                            className='custom-linking-lazy__thumbnail'
                        />,
                        <BlockStack gap="100">
                            <div style={{ maxWidth: "200px" }}>
                                {val?.['item-name']?.length > 25 ?
                                    <Tooltip content={val['item-name']}>
                                        <Text as='p' tone="subdued">{val['item-name'].substring(0, 25)}...</Text>
                                    </Tooltip>
                                    :
                                    <Text as='p' tone="subdued">{val['item-name']}</Text>
                                }
                            </div>
                            <div>{renderStatusOfProduct(val?.['status'])}</div>
                        </BlockStack>
                    </InlineStack>
                    <div>
                        <InlineStack gap="200">
                            <Text as='p'>{t("Seller SKU")}:</Text>
                            <Text as='p' tone="subdued">{val?.['seller-sku']}</Text>
                        </InlineStack>
                        <InlineStack gap="200">
                            <Text as='p'>{t("Barcode")}:</Text>
                            <Text as='p' tone="subdued">{val?.['product-id']}</Text>
                        </InlineStack>
                        <Link url={myContext.viewOnAmazon(val?.['asin1'])} removeUnderline target='_blank'>{t("View On Amazon")}</Link>
                        <div>
                            {val?.['type'] === "variation" ? <Badge tone="info">{t("Parent")}</Badge> : null}
                        </div>
                    </div>
                </InlineStack>
            </BlockStack>
        </div>;
        setFinalData((prevState) => ({ ...prevState, "_id": val._id.$oid, "image-url": val['image-url'], "seller-sku": val['seller-sku'] }));
        setModalData1(modaldata);
    }

    const renderProductToLink = (obj: any) => {
        let dataToLink: any = [];
        dataToLink.push({
            key: "1",
            image: <LazyThumbnail
                src={obj?.items?.["main_image"] && obj?.items?.["main_image"] != "" ? modifyImageUrl(obj?.items?.["main_image"]) : Noimage}
                alt='productImages'
                key={obj?.items?.["main_image"] && obj?.items?.["main_image"] != "" ? modifyImageUrl(obj?.items?.["main_image"]) : Noimage + 'Thumbnail' + Math.random()}
                size='medium'
                className='custom-linking-lazy__thumbnail'
            />,
            title:
                <BlockStack gap='100'>
                    {obj?.['title']?.length > 25 ?
                        <Tooltip content={obj['title']}>
                            <Text as='p' tone="subdued">{obj['title'].substring(0, 25)}...</Text>
                        </Tooltip>
                        :
                        <Text as='p' tone="subdued">{obj['title']}</Text>
                    }
                    <Link url={myContext.viewOnShopify(obj?.['container_id'])} target='_blank' removeUnderline>
                        {t("View on Shopify")}
                    </Link>
                </BlockStack>,
            sku: <Text as='p' tone="subdued">{obj?.items?.['sku'] ?? t("N/A")}</Text>,
            barcode: <Text as='p' tone="subdued">{obj?.items?.['barcode'] ?? t('N/A')}</Text>,
        });
        setFinalData((prevState) => ({ ...prevState, "source_product_id": obj?.items?.['source_product_id'] }));
        setShopifyDataToLink(dataToLink);
    }

    const shouldBtnDisable = (obj: any) => {
        let disable = false;

        if (obj?.items && obj?.items?.shop_id == props.di.globalState.get("target_id") && obj?.items?.status && (obj?.items?.status === "Active" || obj?.items?.status === "Inactive" || obj?.items?.status === "Incomplete" || obj?.items?.status === "Uploaded")) disable = true;
        return disable;
    }

    const renderUnmatchedShopifyProducts = () => {
        let modifiedRows: any = [];
        shopifyProducts?.length > 0 && shopifyProducts.map((obj: any, index: any) => {
            modifiedRows.push({
                key: index,
                // image: <img height={"60px"} width={"60px"} src={obj?.items?.["main_image"] && obj?.items?.["main_image"] != "" ? obj?.items?.["main_image"] : Noimage} />,
                image: <LazyThumbnail
                    src={obj?.items?.["main_image"] && obj?.items?.["main_image"] != "" ? modifyImageUrl(obj?.items?.["main_image"]) : Noimage}
                    alt='productImages'
                    key={obj?.items?.["main_image"] && obj?.items?.["main_image"] != "" ? modifyImageUrl(obj?.items?.["main_image"]) : Noimage + 'Thumbnail' + Math.random()}
                    size='medium'
                    className='custom-linking-lazy__thumbnail'
                />,
                title: <BlockStack gap='100'>
                    {obj?.['title']?.length > 25 ?
                        <Tooltip content={obj['title']}>
                            <Text as='p' tone="subdued">{obj['title'].substring(0, 25)}...</Text>
                        </Tooltip>
                        :
                        <Text as='p' tone="subdued">{obj['title']}</Text>
                    }
                    <Link url={myContext.viewOnShopify(obj?.['container_id'])} removeUnderline target='_blank'>
                        {t("View on Shopify")}
                    </Link>
                </BlockStack>,
                sku: <Text as='p' tone="subdued">{obj?.items?.['sku'] ?? t("N/A")}</Text>,
                barcode: <Text as='p' tone="subdued">{obj?.items?.['barcode'] ?? t('N/A')}</Text>,
                action: !shouldBtnDisable(obj) ? <Button id='' disabled={shouldBtnDisable(obj)} variant='primary' onClick={() => {
                    setLinkModal1(false); handleLink2Modal(); renderProductToLink(obj);
                }}>{t("Link")}</Button> : <Tooltip content={t("This product is already linked.")}>
                    <Button id='' disabled={shouldBtnDisable(obj)} variant='primary' onClick={() => {
                        setLinkModal1(false); handleLink2Modal(); renderProductToLink(obj);
                    }}>{t("Link")}</Button>
                </Tooltip>
            })
        });
        setShopifyData(modifiedRows);
    }





    useEffect(() => {
        renderUnmatchedShopifyProducts();
    }, [shopifyProducts, isVariant]);

    const handleUndoMap = (element: any) => {
        let data: any = {};
        data = {
            ...necessaryDetails,
            'data': {
                _id: element._id,
                source_product_id: element?.["source_product_id"],
            }
        };
        setUndoApproveLoading(true);
        setTableLoading(true);
        props.di.POST(`amazon/product/manualUnmap`, data).then(val => {
            if (val.success) {
                props.success(t(val.message) ?? t("Request Unsuccessful"));
                setSummaryOfTable(<></>);
                setHasApproved(false);
                getUnlinkedListing();
                getUnmatchedShopifyProducts();
            } else {
                props.error(t(val.message) ?? t("Request unsuccessful"));
                setTableLoading(false);
            }
            setUndoApproveLoading(false);
        });
    };

    const renderSummaryOfTable = (type: string, data: any) => {
        let summary: JSX.Element = <Table.Summary fixed="top">
            <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={7}>
                    <InlineStack gap="200" blockAlign="center" wrap={false}>
                        {/* <Thumbnail source={data["image-url"]} size={"medium"} alt="" /> */}
                        <LazyThumbnail
                            src={data["image-url"] && data["image-url"] != "" ? modifyImageUrl(data["image-url"]) : Noimage}
                            alt='productImages'
                            key={data["image-url"] && data["image-url"] != "" ? modifyImageUrl(data["image-url"]) : Noimage + 'Thumbnail' + Math.random()}
                            size='medium'
                            className='custom-linking-lazy__thumbnail'
                        />,
                        <Text as='p' fontWeight="semibold">
                            {t("Linking was successful. You can view the linked product in the Linked Section.")}&nbsp;
                            <Button variant='plain' tone='critical' loading={undoApproveLoading} onClick={() => { handleUndoMap(data) }}>
                                {t("Undo Linking")}
                            </Button>&nbsp;or&nbsp;
                            <Button variant='plain' onClick={() => { myContext.viewProductValue(2, data['seller-sku']) }}>
                                {t("View Linked Product.")}
                            </Button>
                        </Text>
                    </InlineStack>
                </Table.Summary.Cell>
            </Table.Summary.Row>
        </Table.Summary>
        setSummaryOfTable(summary);
        timer = setTimeout(() => {
            setHasApproved(false);
            setSummaryOfTable(<></>);
        }, 30000);
    }

    const toggleActive = useCallback(() => setpopup((popup) => !popup), []);
    const popoveractivator = (
        <Button onClick={toggleActive} disclosure>
            {t("Sort By")}: {sortLabel}
        </Button>
    );

    const handleActionList = (sort: string) => {
        setCurrentPage(1);
        setSortLabel(sort);
    }

    const handleResetAction = () => {
        setSortLabel("");
    }

    const handlePreviousPagination = () => {
        setpageModal(1)
        if (currentPage > 1) setCurrentPage(currentPage - 1);
        setHasPageChanged(!hasPageChanged);
    }

    const handleNextPagination = () => {
        setpageModal(1)
        if (currentPage !== totalPage) setCurrentPage(currentPage + 1);
        setHasPageChanged(!hasPageChanged);
    }




    const handleTableChange = (pagination: any) => {
        setpageModal(pagination)
        // setCurrentPage(pagination.current);
        // setPageSize(pagination.pageSize);
    };




    const rowPerPage: any = 10
    const [page, setpage] = useState(1)
    const [pageModal, setpageModal] = useState(1)
    const [totalPageModal, settotalPageModal] = useState(0)
    const [totalProductCountModal, settotalProductCountModal] = useState(0)


    useEffect(() => {
    }, [totalProductCountModal])

    const getUnmatchedShopifyProducts = async (type = "simple") => {
        setshopifyTableLoading(true);
        let data: any = {}
        data = {
            ...necessaryDetails,
            'activePage': pageModal,
            'count': rowPerPage,
            'type': type == "variation" || variation ? "variation" : "simple"
        }
        if (shopifySearch != "") {
            let filters: any = {};
            filters = {
                'or_filter': { 'items.title': { "3": shopifySearch }, 'items.sku': { "3": shopifySearch } }
            }
            data = Object.assign({ ...data }, filters);
        }
        await props.di.POST(`amazon/product/getVariantsIncludingLinked`, data).then(val => {
            if (val?.success && val?.data) {
                settotalProductCountModal(val?.count?.[0]?.['count'])
                settotalPageModal(val?.count?.[0]?.['count']);

                setShopifyProducts(val.data);
            } else {
                props.error(t(val.error) ?? t("Request unsuccessful"));
            }
            setshopifyTableLoading(false);
        })
    };
    var debounceShopify = debounce(() => { getUnmatchedShopifyProducts(); }, 1000);

    useEffect(() => {
        debounceShopify();
    }, [shopifySearch, pageModal]);
    useEffect(() => {
        return () => {
            debounceShopify.cancel();
        };
    }, [debounceShopify]);

    const customLocale = {
        // Customize the text here
        jump_to: t("Go to"), // Translate "Goto"
        page: t("Page"), // Translate "Page"

    };

    return (
        <div>
            <BlockStack gap='200'>
                <InlineStack gap="100" wrap={false}>
                    <div style={{ flex: '1 1 auto' }}>
                        <TextField
                            onChange={updateText}
                            value={inputValue}
                            prefix={<Icon source={SearchMinor} tone="base" />}
                            placeholder={t("Search by Amazon Title, Barcode, or SKU")}
                            onClearButtonClick={handleClearButtonClick}
                            clearButton={true}
                            label=""
                            autoComplete=""
                        />
                    </div>
                    <div className='custom-sort' style={{ flex: '0 0 auto' }}>
                        <Popover
                            active={popup}
                            activator={popoveractivator}
                            autofocusTarget="first-node"
                            onClose={toggleActive}
                        >
                            <ActionList
                                actionRole="menuitem"
                                sections={[
                                    {
                                        title: t('Title'),
                                        items: [
                                            { content: t('Alphabetically (A-Z)'), onAction: () => handleActionList('A-Z') },
                                            { content: t('Alphabetically (Z-A)'), onAction: () => handleActionList('Z-A') },
                                        ],
                                    },
                                    {
                                        title: t('Status'),
                                        items: statusOption,
                                    },
                                ]}
                            />
                        </Popover>
                    </div>
                </InlineStack>
                <div className={hasApproved ? "custom-productlinking approved" : "custom-productlinking"}>
                    <Card padding="0">
                        {!tableLoading ? (
                            <Table id='failedOrder_tour_6' sticky summary={() => summaryOfTable} loading={tableLoading} columns={unlinkedColumns} dataSource={data} scroll={{ x: 800 }}
                                pagination={false} size='middle' />) : (<UnlinkingSkeleton />)
                        }
                    </Card>
                </div>

                {totalPage > 0 &&
                    <div >
                        <InlineStack align="center" gap='400'>
                            <Pagination
                                label={`${currentPage} / ${totalPage}`}
                                hasPrevious={currentPage <= 1 ? false : true}
                                onPrevious={() => {
                                    handlePreviousPagination()
                                }}
                                hasNext={currentPage === totalPage ? false : true}
                                onNext={() => {
                                    handleNextPagination()
                                }}
                            />
                        </InlineStack>
                    </div>

                }
            </BlockStack>

            <Modal
                size='large'
                open={linkModal1}
                onClose={() => { setvariation(false);setpageModal(1); handleLink1Modal() }}
                title={t("Link Products")}
                footer={
                    <AntdPagination
                        size="small"
                        locale={customLocale}
                        pageSize={rowPerPage}
                        showSizeChanger={false}
                        current={pageModal}
                        total={totalPageModal}
                        onChange={handleTableChange}
                        showTotal={(total) => `${t("Total")} ${total} ${t("items")}`}
                        showQuickJumper
                    />
                }
                secondaryActions={[
                    {
                        content: t('Cancel'),
                        onAction: handleLink1Modal,
                    },
                ]}
            >
                <Modal.Section>
                    <div id='failedOrder_tour_8'>
                        <BlockStack gap="500">
                            {modalData1}
                            <TextField onChange={handleShopifySearch} value={shopifySearch} prefix={<Icon source={SearchMinor} tone="base" />}
                                label=""
                                autoComplete=''
                                placeholder={t("Search by Shopify Title or SKU")}
                            />
                            <Table loading={shopifytableLoading} pagination={false} columns={headings} dataSource={shopifyData} scroll={{ x: 800 }} />
                        </BlockStack>
                    </div>
                </Modal.Section>
            </Modal>

            <Modal
                size='large'
                open={deleteModal}
                onClose={() => { setdeleteModal(false); setmodalLoader(true) }}
                title={t("Delete Products")}
                loading={modalLoader}
                secondaryActions={[
                    {
                        content: t('Cancel'),
                        onAction: () => { setdeleteModal(false); setmodalLoader(true) }
                    },
                    {
                        content: t('Confirm'),
                        onAction: handledeleteproductApi,
                        destructive: true,
                        disabled: modalLoader
                    },
                ]}
            >
                <Modal.Section>
                    <BlockStack gap="500">
                        {modalData1}
                        {
                            dataFoundOnAmazon ?
                                <BlockStack gap='200'>
                                    <Text as='p' fontWeight='semibold'>{t("Product found on Amazon!")}</Text>
                                    <Text as='p' >{t("Are you sure you want to delete this product from the app and Amazon Marketplace?")} </Text>
                                </BlockStack>
                                :
                                <BlockStack gap='200'>
                                    <Text as='p' fontWeight='semibold'>{t("Product not found on Amazon!")}</Text>
                                    <Text as='p'> {t("Are you sure you want to delete this product from the app and Amazon Marketplace?")} </Text>
                                </BlockStack>
                        }
                    </BlockStack>
                </Modal.Section>
            </Modal>

            <Modal
                size='large'
                open={linkModal2}
                onClose={handleBackOfLink2Modal}
                title={t("Link")}
                primaryAction={
                    {
                        content: t('Confirm'),
                        onAction: handleManualMap,
                        loading: modalLinkButton,
                        id: 'failedOrder_tour_9'
                    }
                }
                secondaryActions={[
                    {
                        content: t('Back'),
                        onAction: handleBackOfLink2Modal,
                    },
                ]}
            >
                <Modal.Section>
                    <BlockStack gap="500">
                        {modalData1}
                        <Table columns={headings2} dataSource={shopifyDataToLink} scroll={{ x: 800 }} pagination={false} />
                        <Text as='p' fontWeight="semibold">{t("Are you sure you want to Link the Product?")}</Text>
                    </BlockStack>
                </Modal.Section>
            </Modal>

            {
                syncModal && Object.keys(actiontype)?.length > 0 && (
                    <SyncModal
                        {...props}
                        syncmodalLoading={syncmodalLoading}
                        actiontype={actiontype}
                        syncAction={syncAction}
                        syncModal={syncModal}
                        setsyncModal={setsyncModal}
                    />
                )
            }
        </div >
    )
}
export default DI(Unlinked);